let updateGraph = (price) => {
  let headers = document.querySelectorAll(
    "#life-time-value-chart > table > tbody > tr > td > span"
  )
  let costPerYear = price / 100 / 365
  let costFor5Years = costPerYear / 5
  let costFor10Years = costPerYear / 10
  let arrayOfCost = [costPerYear, costFor5Years, costFor10Years]
  headers.forEach((header, currentIndex) => {
    header.textContent = formatNumber(arrayOfCost[currentIndex])
  })
}

let formatNumber = (number) => {
  return `£${number.toFixed(2)}`
}

window.Shopify.lifeTimeValueUpdate = updateGraph
